<template>
  <v-data-table
    :headers="headers"
    :items="paginatedItems.collection"
    :item-class="itemClass" 
    :items-per-page="paginatedItems.perPage"
    :options.sync="options"
    :server-items-length="paginatedItems.total"
    class="elevation-5 mt-5"
    :expanded.sync="expanded"
    v-on="$listeners"
    v-bind="$attrs"
  >
    <template v-slot:top>
      <v-progress-linear
        v-if="isLoading"
        :indeterminate="true"
        color="accent"
      ></v-progress-linear>
      <v-text-field
        v-if="searchable"
        clearable
        @input="emitDebouncedSearch()"
        v-model="search"
        placeholder="ابحث"
        class="px-2"
      >
        <template v-slot:append>
          <v-icon large color="lightSecondary">mdi-magnify</v-icon>
        </template>
      </v-text-field>
    </template>

    <template v-slot:[`item.actions`]="{ item }">
      <slot name="actions" :item="item"></slot>
    </template>

    <template
      v-for="(_, name) in $scopedSlots"
      :slot="name"
      slot-scope="slotData"
    >
      <slot :name="name" v-bind="slotData"></slot>
    </template>

    <!-- Row expansion slot -->
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        <slot name="expansion" :item="item"></slot>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import { useGlobalStore } from "@/store/GlobalStore";
import { mapState } from "pinia";

export default {
  name: "BaseDataTable",
  props: {
    headers: Array,
    paginatedItems: Object,
    itemClass: { type: [String, Function], default: "" },
    searchable: {
      type: Boolean,
      default: true,
    },
    tableKey: {
      type: String,
      required: false,
    },
  },
  computed: {
    ...mapState(useGlobalStore, ["isLoading"]),
  },
  data() {
    return {
      expanded: [],
      options: {
        page: 1,
        itemsPerPage: 5,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
      },
      search: null,
      searchTimeout: null,
    };
  },
  created() {
    // Restore pagination state if available
    if (this.tableKey) {
      const savedState = localStorage.getItem(`table_state_${this.tableKey}`);
      if (savedState) {
        try {
          const parsed = JSON.parse(savedState);
          if (parsed.page) this.options.page = parsed.page;
          if (parsed.itemsPerPage)
            this.options.itemsPerPage = parsed.itemsPerPage;
        } catch (e) {
          console.warn("Invalid saved table state:", e);
        }
      }
    }
  },
  watch: {
    options: {
      deep: true,
      handler(newVal) {
        this.$emit("optionsChanged", newVal);
        if (this.tableKey) {
          localStorage.setItem(
            `table_state_${this.tableKey}`,
            JSON.stringify({
              page: newVal.page,
              itemsPerPage: newVal.itemsPerPage,
            })
          );
        }
      },
    },
  },
  methods: {
    emitDebouncedSearch() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.$emit("debouncedSearch", this.search);
      }, 500);
    },
  },
};
</script>
<style scoped>
::v-deep .row-highlight td {
  background-color: var(--v-primary-base) !important;
  color: var(--v-light-base) !important;
}

::v-deep .row-highlight {
  border-right: 6px solid var(--v-primary-base) !important;
}

::v-deep .row-highlight a,
::v-deep .row-highlight .v-btn,
::v-deep .row-highlight .v-btn__content,
::v-deep .row-highlight .v-icon {
  color: var(--v-light-base) !important;
}

::v-deep .row-highlight:hover td {
  background-color: transparent !important;
  color: inherit !important;
}

::v-deep .row-highlight:hover {
  border-right-color: transparent !important;
}

::v-deep .row-highlight:hover a,
::v-deep .row-highlight:hover .v-btn,
::v-deep .row-highlight:hover .v-btn__content,
::v-deep .row-highlight:hover .v-icon {
  color: inherit !important;
}
</style>
